import { render, staticRenderFns } from "./UploadHoldingsCSV.vue?vue&type=template&id=64f397c1&scoped=true&"
import script from "./UploadHoldingsCSV.vue?vue&type=script&setup=true&lang=js&"
export * from "./UploadHoldingsCSV.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UploadHoldingsCSV.vue?vue&type=style&index=0&id=64f397c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f397c1",
  null
  
)

export default component.exports